<template>
  <aside class="ModalVideo" id="ModalVideo">
    <div class="overlay" @click="closeModal"></div>
    <div class="modal_wrapper" id="ModalWrapper">
      <div class="close" @click="closeModal"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="#030047"/></svg></div>
      <div
        class="video_content">
        <div class="video_wrapper">
            <div class="video"><iframe width="100%" :src="'https://www.youtube.com/embed/'+getVideoId(url)+'?rel=0&amp;amp;amp;amp;showinfo=0;allow=&quot;accelerometer;autoplay=1'" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen="allowfullscreen"></iframe></div>
        </div>
      </div>
    </div>
  </aside>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      required: true
    }
  },
  mounted () {
    console.log('opeed', this.url)
    this.$nextTick(() => {
      let heightDocument = document.getElementById('ModalVideo').scrollHeight
      let heightModal= document.getElementById('ModalWrapper').clientHeight
      let calcMargin = (heightDocument - heightModal) / 2
      document.getElementById('ModalWrapper').style.margin = `${calcMargin}px auto`
    })
  },
  methods: {
    closeModal () {
      this.$emit('closeModal')
    },
    getVideoId (url) {
      console.log('url', url)
      const code = url.match(/v=([^&#]{5,})/)
      return (typeof code[1] == 'string') ? code[1] : false;
    }
  }
}
</script>

<style lang="sass" >
@import '../assets/css/variables'

.ModalVideo
  position: absolute
  left: 0
  top: 0
  width: 100%
  height: 100vh
  z-index: 20
  overflow: auto
  padding: 0 30px
  box-sizing: border-box
  .overlay
    background-color: rgba(black, .8)
    width: 100%
    height: 100%
    position: fixed
    left: 0
    top: 0
    z-index: 12
  .modal_wrapper
    background-color: black
    width: 100%
    max-width: 1300px
    overflow: hidden
    z-index: 13
    position: relative
    padding: 50px 0
    box-sizing: border-box
    margin: 50px auto
    display: flex
    flex-direction: column
    justify-content: center
    box-shadow: 0 4px 25px 2px rgba(black, .1)
    .close
      width: 50px
      height: 50px
      position: absolute
      right: 10px
      top: 10px
      display: flex
      align-items: center
      justify-content: center
      border-radius: 50%
      cursor: pointer
      background-color: transparent
      transition: background-color ease-in-out .2s
      svg path
        fill: white
    .video_content
      .video_wrapper
        padding-top: 0
        .video
          position: relative
          padding-bottom: 56.25%
          height: 0
          overflow: hidden
          iframe
            position: absolute
            top: 0
            left: 0
            width: 100%
            height: 100%

@media screen and (max-width: 620px)
  .ModalVideo
    padding: 0 20px
    .modal_wrapper
      padding: 70px 0
</style>
